export type IframeScenario = 'BizChatSidebar' | 'HelpPane';

export type ScenarioSettings = {
    enablePreloading: boolean;
    enableCaching: boolean;
    matchUrl: (url: string) => boolean;
};

export const iframesMapping: Record<IframeScenario, ScenarioSettings> = {
    BizChatSidebar: {
        enablePreloading: true,
        enableCaching: true,
        matchUrl: (url: string) =>
            url.includes('/hosted/semanticoverview/') || url.includes('about:blank'), // The 'about:blank' if temporary while we figure out why the iframe sometimes reports its source as that
    },
    HelpPane: {
        enablePreloading: false,
        enableCaching: false,
        matchUrl: (url: string) => url.includes('https://support.office.com/client/results'),
    },
};
